import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { REPORT_LINK_KEY, ReportLinkKey } from '@/shared/model';
import { useReportValidationStore } from '@/store';

import { NECK_SUB_ORGAN } from './nav-menu.constant';

export function useUpdateSubOrganStatus(linkKey: ReportLinkKey, subOrganLink: null | string[]) {
  const { getStatus, links, setStatus } = useReportValidationStore(
    useShallow((state) => ({
      getStatus: state.getStatus,
      links: state.links,
      setStatus: state.setStatus,
    })),
  );

  useEffect(() => {
    if (linkKey === REPORT_LINK_KEY.NECK && subOrganLink) {
      const allSubOrgansDone = NECK_SUB_ORGAN.every((subOrgan) => {
        const status = getStatus(subOrgan);

        return status?.done && !status?.error && !status?.warning;
      });

      const currentNeckStatus = getStatus(REPORT_LINK_KEY.NECK);

      if (
        allSubOrgansDone &&
        (!currentNeckStatus?.done || currentNeckStatus?.error || currentNeckStatus?.warning)
      ) {
        setStatus(REPORT_LINK_KEY.NECK, { done: true, error: false, warning: false });
      } else if (
        !allSubOrgansDone &&
        (currentNeckStatus?.done || currentNeckStatus === undefined)
      ) {
        setStatus(REPORT_LINK_KEY.NECK, { done: false, error: false, warning: false });
      }
    }
  }, [linkKey, subOrganLink, getStatus, setStatus, links]);
}
